module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-900.8b546a21.eot";